export default "__VITE_ASSET__CQuRNwI2__"